var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPravachanCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_45",
    x: 0,
    y: 0,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.09
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prawachan",
    transform: "translate(-222.5 -175.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    transform: "translate(236.333 186)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -13.83, -10.5)",
    filter: "url(#Rectangle_45)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45-2",
    "data-name": "Rectangle 45",
    width: 61,
    height: 61,
    rx: 30.5,
    transform: "translate(13.5 10.5)",
    fill: "#fe8901"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "prawachan-2",
    "data-name": "prawachan",
    transform: "translate(-2266.875 -111.647)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M2527.193,358.983c-.622,0-1.087,0-1.269-.007a3.729,3.729,0,0,1-1.958-.565,3.411,3.411,0,0,1-1.3-1.624,3.452,3.452,0,0,1,.874-3.926l.887-.909c.778-.8,1.573-1.612,2.378-2.419-.234.172-.469.348-.7.519-.62.464-1.261.945-1.927,1.385a2.808,2.808,0,0,1-2.14.429,2.7,2.7,0,0,1-1.719-1.2,2.8,2.8,0,0,1,.765-3.821c.211-.157.417-.318.635-.488a13.664,13.664,0,0,1,1.734-1.215,8.277,8.277,0,0,0,3.929-5.117,2.869,2.869,0,0,1,1.844-2.219l.024-.007a12.081,12.081,0,0,1,3.583-.227c.483.019.941.036,1.4.029l.509-.009c1.595-.029,2.475-.045,3.185.452s1,1.287,1.58,2.871l.1.283a6.131,6.131,0,0,0,2.587,3.3,38.169,38.169,0,0,1,3.217,2.346l.034.027a2.729,2.729,0,0,1,.649,3.945,2.784,2.784,0,0,1-3.985.453c-.81-.576-1.622-1.167-2.419-1.75.534.552,1.06,1.108,1.575,1.653.49.518,1,1.053,1.5,1.573a3.432,3.432,0,0,1,1.043,3.759,3.562,3.562,0,0,1-3.628,2.46h-.059c-1.773-.018-3.58-.013-5.327-.007l-1.472,0-1.395.006C2530.467,358.974,2528.492,358.983,2527.193,358.983Zm2.208-13.089a.78.78,0,0,1,.776.7,3.167,3.167,0,0,1-1.012,2.8c-1.225,1.19-2.442,2.438-3.618,3.644l-.89.911a1.923,1.923,0,0,0-.543,2.248,1.846,1.846,0,0,0,1.854,1.217c.535.015,3.931,0,5.96-.008h.12c.026,0,.053,0,.08,0h1.556l1.113,0c1.752-.005,3.563-.011,5.348.008h.046a2.019,2.019,0,0,0,2.159-1.431c.262-.724.053-1.366-.7-2.146-.507-.525-1.016-1.064-1.508-1.584-.852-.9-1.733-1.832-2.622-2.716a4.181,4.181,0,0,1-1.346-2.692.779.779,0,0,1,.8-.848,2.211,2.211,0,0,1,1.348.583c.056.044.109.085.159.121.5.364,1.007.735,1.5,1.095,1,.73,2.027,1.485,3.048,2.211a1.239,1.239,0,0,0,1.828-.109,1.208,1.208,0,0,0-.357-1.79l-.034-.027a37.009,37.009,0,0,0-3.084-2.252,7.7,7.7,0,0,1-3.22-4.078l-.1-.284a5.762,5.762,0,0,0-1.011-2.133,5.3,5.3,0,0,0-2.262-.17l-.513.009c-.5.008-1-.011-1.483-.03a10.79,10.79,0,0,0-3.118.174c-.4.123-.565.463-.781,1.174a9.765,9.765,0,0,1-4.661,6.025,12.308,12.308,0,0,0-1.534,1.082c-.216.169-.439.343-.667.512a1.256,1.256,0,0,0-.382,1.726,1.148,1.148,0,0,0,.729.513,1.263,1.263,0,0,0,.958-.2c.627-.415,1.25-.881,1.852-1.332.279-.209.567-.424.854-.635l1.843-1.347,1.067-.779A.779.779,0,0,1,2529.4,345.893Z",
    transform: "translate(0 -15.081)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M2542.328,381.419h0a3.137,3.137,0,0,1-2.284-.85,2.979,2.979,0,0,1,2.329-4.976c.885-.01,1.782-.008,2.731-.006l1.4,0a.39.39,0,0,1,0,.78l-1.407,0c-.947,0-1.841,0-2.72.006a2.2,2.2,0,0,0-1.783,3.649,2.382,2.382,0,0,0,1.732.618.39.39,0,0,1,0,.78Z",
    transform: "translate(-11.555 -37.93)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M2545.627,323.639h-.07a5.53,5.53,0,0,1-5.419-5.473,5.5,5.5,0,0,1,5.471-5.519h.017a5.414,5.414,0,0,1,3.861,1.6,5.505,5.505,0,0,1-3.861,9.389Zm0-9.433h-.012a3.942,3.942,0,0,0-3.917,3.948,3.962,3.962,0,0,0,3.879,3.925h.05a3.946,3.946,0,0,0,2.756-6.729A3.865,3.865,0,0,0,2545.627,314.206Z",
    transform: "translate(-12.272)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPravachanCircle);
export default __webpack_public_path__ + "static/media/pravachanCircle.1c63be158775823e08191323491e2936.svg";
export { ForwardRef as ReactComponent };